export var onClickByMouseDown = function onClickByMouseDown(event, callback) {
  event.preventDefault();
  if (event.button !== 0) {
    return;
  }
  if (callback) {
    callback(event);
  }
};